import gql from "graphql-tag";

export default gql`mutation CreateVatToken($test:Boolean!, $redirectUri:String!, $code:String!) {
    createVatToken(test:$test, redirectUri:$redirectUri, code:$code)
  }`